import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import Grid from 'components/Grid';
import OffsetSlider from 'components/sliders/OffsetSlider';
import Section from 'components/Section';
import SizeDependedBlock from 'components/SizeDependedBlock';
import VirtualTourCard from 'components/cards/entities/VirtualTourCard';

import { VirtualTourType } from 'propTypes/entities';

import styles from '../styles.module.scss';

const VirtualTours = ({ entities, subtitle }) => {
	const renderCards = () =>
		_(entities).map((entity) => (
			<VirtualTourCard
				key={entity._id}
				className={styles.cardSquare}
				entity={entity}
			/>
		));

	return (
		<Section
			title="Виртуальные туры"
			url="/museums/institutes/location-russia/hasVirtualTours-true"
			align="center"
			titleSize="medium"
			subtitle={subtitle}
		>
			<SizeDependedBlock breakpoint="tabletMedium">
				<OffsetSlider>{renderCards()}</OffsetSlider>
				<Container>
					<Grid align="spaceBetween" flexibleWidth>
						{renderCards()}
					</Grid>
				</Container>
			</SizeDependedBlock>
		</Section>
	);
};

VirtualTours.propTypes = {
	entities: PropTypes.arrayOf(VirtualTourType).isRequired,
	subtitle: PropTypes.string
};

export default VirtualTours;
